import { withManagedForm } from "@/application/components/admin/connections/managedForm";

export function editConnectionForm({ allowlistedInputs = [] }) {
  const form = {
    initChild() {
      this.filterMultiSelectChange = this.filterMultiSelectChange.bind(this);
    },
    filterMultiSelectChange(_parent, value, name) {
      const fieldName = this.nameToKey(name);
      this[fieldName] = JSON.stringify(value);
      this.watch(this.nameToKey(name))(this[fieldName]);
    },
    comparatorJsonArrays(initialValue, currentValue) {
      // Specifically formulated for multi selects with the array type
      try {
        const initialSet = new Set(JSON.parse(initialValue));
        const currentSet = new Set(JSON.parse(currentValue));
        let itemsRemoved = false;
        for (const item of initialSet) {
          if (!currentSet.has(item)) {
            itemsRemoved = true;
            break;
          }
        }
        return itemsRemoved;
      } catch (e) {
        return false;
      }
    },
  };
  return withManagedForm(
    { formRef: "editConnectionForm", allowlistedInputs },
    form,
  );
}
